import React from "react";

import { DetailsSection } from "../../../DetailsSection/DetailsSection";
import { Step } from "../../../DetailsSection/modules/Step/Step";
import { FEATURE_SECTIONS_STEPS } from "../../constants/EmailSenderUnlockModal.constants";

export const FeaturesSection = () => {
  return (
    <DetailsSection
      title={
        <>
          You also{" "}
          <span className="tw-text-[#493ab1]">unlock the following</span> with
          this purchase
        </>
      }
    >
      {FEATURE_SECTIONS_STEPS.map((step, index) => (
        <Step
          key={step.id}
          {...step}
          isLast={index === FEATURE_SECTIONS_STEPS.length - 1}
        />
      ))}
    </DetailsSection>
  );
};
